import L from 'leaflet';
import { redIcon, greenIcon, blueIcon } from './mapIcons';
import { LocationColor, MapPoint } from '../../Interfaces/Map';

export const getIconForPoint = (point: MapPoint) => {
    switch (LocationColor[point?.type]) {
        case 'red':
            return redIcon;
        case 'green':
            return greenIcon;
        case 'blue':
            return blueIcon;
        default:
            return redIcon;
    }
};

interface ClusterMarker {
    options: {
        icon: L.Icon;
    };
}

interface MarkerCluster {
    getChildCount(): number;
    getAllChildMarkers(): ClusterMarker[];
}

export const createClusterIcon = (cluster: MarkerCluster) => {
    const count = cluster.getChildCount();
    const markers = cluster.getAllChildMarkers();

    const colorSet = new Set<string>();
    
    markers.forEach((marker: ClusterMarker) => {
        const icon = marker.options.icon;
        if (icon === redIcon) {
            colorSet.add('red');
        } else if (icon === greenIcon) {
            colorSet.add('green');
        } else if (icon === blueIcon) {
            colorSet.add('blue');
        }
    });

    // If all markers are the same color, use that color; otherwise use purple for mixed
    const color = colorSet.size === 1 ? Array.from(colorSet)[0] : 'purple';

    return L.divIcon({
        html: `<div style="background-color: ${color}; color: white; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-weight: bold; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);">${count}</div>`,
        className: 'custom-cluster-icon',
        iconSize: [40, 40]
    });
};

const getLatitude = (address: any) => {
    if (address?.location?.latitude) return address.location.latitude;
    if (Array.isArray(address?.location) && address?.location[0]?.latitude) return address.location[0].latitude;
    if (address?.geoLocation?.coordinates) return address.geoLocation.coordinates[0];
    if (address?.location?.coordinates) return address.location.coordinates[0];
    return null;
};

const getLongitude = (address: any) => {
    if (address?.location?.longitude) return address.location.longitude;
    if (Array.isArray(address?.location) && address?.location[0]?.longitude) return address.location[0].longitude;
    if (address?.geoLocation?.coordinates) return address.geoLocation.coordinates[1];
    if (address?.location?.coordinates) return address.location.coordinates[1];
    return null;
};

export const fetchCoordinates = (address: any): [number, number] => {
    const latitude = getLatitude(address);
    const longitude = getLongitude(address);
    return [latitude, longitude];
}

export const isValidCoordinate = (lat: number, lng: number): boolean => {
    return typeof lat === 'number' && typeof lng === 'number' &&
        !isNaN(lat) && !isNaN(lng) &&
        lat >= -90 && lat <= 90 &&
        lng >= -180 && lng <= 180;
};